"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpfulContentType = void 0;
var HelpfulContentType;
(function (HelpfulContentType) {
    HelpfulContentType["LESSON"] = "lesson";
    HelpfulContentType["COURSE"] = "course";
    HelpfulContentType["CHALLENGE"] = "challenge";
})(HelpfulContentType = exports.HelpfulContentType || (exports.HelpfulContentType = {}));
